import { G_BUTTON__image_edit__mask_clear } from './_buttons/G_BUTTON__image_edit__mask_clear';
import { G_BUTTON__image_edit__mask_invert } from './_buttons/G_BUTTON__image_edit__mask_invert';
import { G_BUTTON__image_edit__mask_maximize } from './_buttons/G_BUTTON__image_edit__mask_maximize';
import G_SELECTOR__image_mask_brush from './_buttons/G_SELECTOR__image_mask_brush';

export function G_SIDEBAR__IMAGE_EDIT__mask() {
  return (
    <div className="size-full flex flex-col items-start justify-start gap-2 p-2">
      <G_BUTTON__image_edit__mask_invert />
      <G_BUTTON__image_edit__mask_maximize />
      <G_BUTTON__image_edit__mask_clear />

      <G_SELECTOR__image_mask_brush />
    </div>
  );
}
